export const FEATURE_CONSTS = {
    GET_FEATURES: "GET_FEATURES",
    CREATE_FEATURE: "CREATE_FEATURE",
    UPDATE_FEATURE_BY_ID: "UPDATE_FEATURE_BY_ID",
    DELETE_FEATURE_BY_ID: "DELETE_FEATURE_BY_ID",
};
